import React from 'react';
import { Collapse, CollapseProps } from 'antd';
import styled from 'styled-components';
import { Icon } from 'src/components/general/icon';

const StyledCollapseContainer = styled(Collapse as React.FC<CollapseProps>)`
  &.desktop-collapse {
    border-radius: 6px;
  }
  .ant-collapse-content {
    background-color: ${({ theme }) => theme.colors.porcelain};
  }
  .ant-collapse-content-box {
    padding: 15px 0 !important;
  }
  .ant-collapse-header {
    color: ${({ theme }) => theme.colors.smalt} !important;
    font-family: ${({ theme }) => theme.font.medium};
    font-size: 13px;
    letter-spacing: -0.26px;
    line-height: 16px !important;
    padding: 12px 20px !important;
    background-color: ${({ theme }) => theme.colors.alabaster} !important;
    border-top: 1px solid ${({ theme }) => theme.colors.porcelain2};
    border-bottom: none;
  }
  .ant-collapse-item.ant-collapse-item-active .ant-collapse-header,
  .ant-collapse-item:last-child .ant-collapse-header {
    border-bottom: 1px solid ${({ theme }) => theme.colors.porcelain2};
  }

  &.desktop-collapse .ant-collapse-header:first-child {
    border-top: none !important;
    border-radius: 6px 6px 0 0;
  }

  .ant-collapse-arrow {
    left: unset !important;
    right: 20px !important;
    color: ${({ theme }) => theme.colors.flint} !important;
  }

  .active svg {
    transform: rotate(-180deg) !important;
  }
  .ant-collapse-arrow svg {
    transform: rotate(0deg);
    transition: 0.24s ease-out !important;
  }
`;

export type StyledCollapseProps = CollapseProps & {
  expandIconClassName?: string;
};

export const StyledCollapse: React.FC<StyledCollapseProps> = ({
  expandIcon,
  expandIconClassName = 'arrow-icon',
  ...props
}) => (
  <StyledCollapseContainer
    expandIcon={
      expandIcon ??
      (({ isActive }) => (
        <Icon
          className={`${expandIconClassName || ''} ${isActive ? 'active' : ''}`}
          type="chevronDown"
        />
      ))
    }
    {...props}
  />
);

export const Panel = Collapse.Panel;
